let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jgM23")).then(() => parcelRequire('39Wx8'));